var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 20.6172C11.4459 20.6172 9.84121 20.2312 8.22637 19.4746C6.96191 18.8805 5.6873 18.0578 4.43809 17.027C2.33066 15.2852 1.03066 13.5586 0.974805 13.4875C0.756445 13.198 0.756445 12.802 0.974805 12.5125C1.03066 12.4414 2.33066 10.7148 4.43809 8.97305C5.6873 7.94219 6.96191 7.11953 8.22637 6.52539C9.84121 5.76875 11.4459 5.38281 12.9998 5.38281C14.5537 5.38281 16.1584 5.76875 17.7732 6.52539C19.0377 7.11953 20.3123 7.94219 21.5615 8.97305C23.6689 10.7148 24.974 12.4414 25.0248 12.5125C25.2432 12.802 25.2432 13.198 25.0248 13.4875C24.9689 13.5586 23.6689 15.2852 21.5615 17.027C20.3123 18.0578 19.0377 18.8805 17.7732 19.4746C16.1584 20.2312 14.5537 20.6172 12.9998 20.6172ZM2.6709 13C3.94551 14.5082 8.15527 18.9922 12.9998 18.9922C17.8545 18.9922 22.0541 14.5082 23.3287 13C22.0541 11.4918 17.8443 7.00781 12.9998 7.00781C8.14512 7.00781 3.94551 11.4918 2.6709 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.6562C10.984 16.6562 9.34375 15.016 9.34375 13C9.34375 10.984 10.984 9.34375 13 9.34375C15.016 9.34375 16.6562 10.984 16.6562 13C16.6562 15.016 15.016 16.6562 13 16.6562ZM13 10.9688C11.8777 10.9688 10.9688 11.8777 10.9688 13C10.9688 14.1223 11.8777 15.0312 13 15.0312C14.1223 15.0312 15.0312 14.1223 15.0312 13C15.0312 11.8777 14.1223 10.9688 13 10.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewWhite);
export default __webpack_public_path__ + "static/media/viewWhite.a12a5a3105eb626d557dfbc244849490.svg";
export { ForwardRef as ReactComponent };